import { useUiStore } from '../../stores/uiStore.js';

function handleLogout() {
  import('../../auth/session.js')
    .then(({ logout }) => logout())
    .catch(() => {});
}

/**
 * @param {import('@apollo/client/link/error').ErrorLink.ErrorHandlerOptions} options
 */
export function errorHandler({ graphQLErrors, networkError, operation, forward }) {
  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      const code = err.extensions?.code;
      if (
        code === 'UNAUTHENTICATED' ||
        err.message?.includes('Not authorized') ||
        err.message?.includes('Unauthorized')
      ) {
        handleLogout();
        return;
      }
      if (code === 'VALIDATION_ERROR') {
        useUiStore.getState().addToast({
          type: 'error',
          message: err.message || 'Validation error',
        });
      }
    }
  }

  if (networkError) {
    if ('statusCode' in networkError && networkError.statusCode === 401) {
      handleLogout();
      return;
    }
    useUiStore.getState().addToast({
      type: 'error',
      message: 'Network error. Please check your connection.',
    });
  }

  return forward(operation);
}
